import { createFileRoute } from '@tanstack/react-router';
import TwoFactorEnable from '@src/pages/Auth/TwoFactorEnable';

import { getLocalizedTitle } from '../title';

export const Route = createFileRoute('/auth/2fa-enable')({
  head: () => ({
    meta: [
      {
        title: getLocalizedTitle(
          'auth.two_factor_authentication',
          'Two-Factor Authentication',
        ),
      },
    ],
  }),
  component: TwoFactorEnable,
});
